export const apiPath = '/v2/user/notification_preference';
const actionType = 'USER_NOTIFICATION_PREFERENCE';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
